import { compose, withProps } from 'recompose'
import withType from 'components/common/hoc/withType'
import Button from 'components/Appointment/Button'

export default compose(
  withType({ type: 'BOTQuickAppointmentContinue' }),
  withProps({
    isFromOnlineAppointment: true
  })
)(Button)
